import { MessageSquareQuoteIcon } from "lucide-react";
import moment from "moment";

import { useEvent } from "../changelog-item-context";

import EventTitle from "./EventTitle";
import { getCommitMessage } from "./utils";

const EventHeader = () => {
  const event = useEvent();

  const commitMessage = getCommitMessage(event);

  return (
    <div className="mb-2 flex w-full min-w-0 flex-col gap-y-1">
      <div className="flex w-full min-w-0 flex-wrap items-start justify-between gap-x-4 gap-y-1 sm:flex-nowrap sm:items-center">
        <div className="min-w-0 flex-1">
          <EventTitle />
        </div>
        <div className="flex-shrink-0 self-start whitespace-nowrap text-xs text-gray-500">
          {moment(event.datetime).fromNow()}
        </div>
      </div>

      {commitMessage && (
        <div className="flex min-w-0 flex-row items-start gap-2 text-sm font-normal text-gray-700">
          <MessageSquareQuoteIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-gray-400" />
          <span className="break-words">{commitMessage}</span>
        </div>
      )}
    </div>
  );
};

export default EventHeader;
